<div class="state-collapsible-header" (click)="showRule = !showRule">
  <button mat-button (click)="onDeleteButtonClick()">
    <mat-icon>delete</mat-icon>
  </button>
  <span>{{ rule.Description }}</span>
  <span class="placeholder"></span>
  <div class="clear"></div>
</div>
@if (showRule) {
  <div class="state-collapsible-content">
    <div>
      <mat-form-field class="state-editor-marginright state-editor-longfield">
        <input matInput placeholder="Rule Name" [(ngModel)]="rule.Description" required [disabled]="!ruleIsEditable()" />
      </mat-form-field>
      @if (!ruleIsEditable()) {
        <a mat-raised-button class="mat-accent" (click)="onEditButtonClick()">Edit Rule</a>
      }
      <br />
    </div>
    <h4>Conditions @if (ruleIsEditable()) {
      <button mat-icon-button (click)="onAddConditionButtonClick()"><mat-icon>add</mat-icon></button>
    }</h4>
    @for (condition of rule.Conditions; track condition) {
      <my-modules-condition
        [rule]="rule"
        [condition]="condition"
        [conditionFields]="conditionFields"
        [listItemsCache]="listItemsCache"
        [disabled]="!ruleIsEditable()">
      </my-modules-condition>
    }
  </div>
}